import React, { useState, useRef } from "react";
import {
  Box,
  Stack,
  TextField,
  TextareaAutosize,
  Typography,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";

export default function MessageForm({ matches }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const { t } = useTranslation();
  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleComment = (event) => {
    setComment(event.target.value);
  };
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const service_id = "service_dwpn74x";
    const templete_id = "template_y26ag7v";
    const public_key = "FjyaUwYaMFEebx_vB";

    emailjs.sendForm(service_id, templete_id, form.current, public_key).then(
      (result) => {
        if (result.text === "OK") {
          alert(t("Message Send Successfully"));
          setName("");
          setEmail("");
          setComment("");
          window.location.reload(true);
        }
      },
      (error) => {
        console.log(error.text);
      }
    );
  };
  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      style={{
        backgroundColor: "#FFFFFF",
        width: matches ? "500px" : "300px",
        boxShadow: "10px 10px 10px #E1E2E4FF",
        borderRadius: "20px",
        marginBottom: "5%",
        padding: "20px",
      }}
    >
      <Stack direction="row" gap={1}>
        <Box>
          <Typography sx={{ color: "#0F237A" }}>{t("Full Name")}</Typography>
          <TextField
            onChange={handleNameChange}
            sx={{ width: "100%" }}
            size="small"
            name="from_name"
          />
        </Box>
        <Box>
          <Typography sx={{ color: "#0F237A" }}>{t("Email")}</Typography>
          <TextField
            onChange={handleEmailChange}
            name="from_email"
            type="email"
            sx={{ width: "100%" }}
            size="small"
          />
        </Box>
      </Stack>
      <br />

      <Typography sx={{ color: "#0F237A" }}>
        {t("How can we help ?")}
      </Typography>
      <TextareaAutosize
        onChange={handleComment}
        name="message"
        minRows={4}
        cols={matches ? 54 : 15}
        sx={{ width: "100%" }}
      />
      <br />
      <br />

      <Button
        type="submit"
        sx={{
          backgroundColor: "#1D2877",
          color: "white",
          width: "99%",
          "&:hover": { backgroundColor: "#1D2877" },
        }}
      >
        {t("Send Message")}
      </Button>
      <br />
      <br />
    </form>
  );
}
